import { Component, OnDestroy, OnInit, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ServiceAppEntityServiceRead } from '../../../openapi';
import { selectApplication, selectLoading, selectPending } from '../../../store/selectors/application.selectors';
import { selectServiceByUrl } from '../../../store/selectors/app.selectors';
import { Store } from '@ngrx/store';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { UploaderAttachmentsService } from '../../../services/uploader-attachments.service';
import {
  loadApplication,
  loadPayments, loadRoadOccupationTypes, loadServiceAttachmentPositions,
  setApplication,
  setPayments,
  setShipments
} from '../../../store/actions/application.actions';
import { ContentComponent } from '../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { PdfGeneratorService } from '../../../services/pdf.generator.service';
import { AlertContainerComponent, AlertService } from '../../../common/alert-container/alert-container.component';
import {
  WLocationPropertyInRevitalizationAreaPreviewComponent
} from '../application/w-location-property-in-revitalization-area/w-location-property-in-revitalization-area-preview/w-location-property-in-revitalization-area-preview.component';
import {
  WCertificateFromMunicipalRegisterPreviewComponent
} from '../application/w-certificate-from-municipal-register/w-certificate-from-municipal-register-preview/w-certificate-from-municipal-register-preview.component';
import {
  WExtractAndDraftMpzpPreviewComponent
} from '../application/w-extract-and-draft-mpzp/w-extract-and-draft-mpzp-preview/w-extract-and-draft-mpzp-preview.component';
import {
  WExtractAndDraftFromStudyPreviewComponent
} from '../application/w-extract-and-draft-from-study/w-extract-and-draft-from-study-preview/w-extract-and-draft-from-study-preview.component';
import {
  CertAboutConformityOfUseWithMpzpPreviewComponent
} from '../application/cert-about-conformity-of-use-with-mpzp/cert-about-conformity-of-use-with-mpzp-preview/cert-about-conformity-of-use-with-mpzp-preview.component';
import {
  OpinionOfConformityPreviewComponent
} from '../application/opinion-of-conformity/opinion-of-conformity-preview/opinion-of-conformity-preview.component';
import {
  IrspaApplicationForTheProjectPreviewComponent
} from '../application/irspa-application-for-the-project/irspa-application-for-the-project-preview/irspa-application-for-the-project-preview.component';
import {
  IrspaWarningOnTheConsultedDraftPreviewComponent
} from '../application/irspa-warning-on-the-consulted-draft/irspa-warning-on-the-consulted-draft-preview/irspa-warning-on-the-consulted-draft-preview.component';
import {
  IrspaAmendTheActPreviewComponent
} from '../application/irspa-amend-the-act/irspa-amend-the-act-preview/irspa-amend-the-act-preview.component';
import {
  IrspaPreparationOfTheActPreviewComponent
} from '../application/irspa-preparation-of-the-act/irspa-preparation-of-the-act-preview/irspa-preparation-of-the-act-preview.component';
import {
  DocumentsInformationPreviewComponent
} from '../application/documents-information/documents-information-preview/documents-information-preview.component';
import {
  GeneralLetterPreviewComponent
} from '../application/general-letter/general-letter-preview/general-letter-preview.component';
import {
  ResponseToCallPreviewComponent
} from '../application/response-to-call/response-to-call-preview/response-to-call-preview.component';
import {
  CertAboutConformityOfStudyPreviewComponent
} from '../application/cert-about-conformity-of-study/cert-about-conformity-of-study-preview/cert-about-conformity-of-study-preview.component';
import {
  LeaseOfABurialPlacePreviewComponent
} from '../application/lease-of-a-burial-place/lease-of-a-burial-place-preview/lease-of-a-burial-place-preview.component';
import {
  ApplicationForACemeterySpacePreviewComponent
} from '../application/application-for-a-cemetery-space/application-for-a-cemetery-space-preview/application-for-a-cemetery-space-preview.component';
import {
  RegistrationForTheSewageTreatmentPlantRegisterPreviewComponent
} from '../application/registration-for-the-sewage-treatment-plant-register/registration-for-the-sewage-treatment-plant-register-preview/registration-for-the-sewage-treatment-plant-register-preview.component';
import {
  WDeterminingPlanningFeeBeforeSaleOfPropertyPreviewComponent
} from '../application/w-determining-planning-fee-before-sale-of-property/w-determining-planning-fee-before-sale-of-property-preview/w-determining-planning-fee-before-sale-of-property-preview.component';
import {
  SubmittingAnInvestorLetterOfIntentPreviewComponent
} from '../application/submitting-an-investor-letter-of-intent/submitting-an-investor-letter-of-intent-preview/submitting-an-investor-letter-of-intent-preview.component';
import {
  GeneralApplicationPreviewComponent
} from '../application/general-application/general-application-preview/general-application-preview.component';
import {
  RemovalOfTreesOrShrubsPreviewComponent
} from '../application/removal-of-trees-or-shrubs/removal-of-trees-or-shrubs-preview/removal-of-trees-or-shrubs-preview.component';
import {
  MunicipalWasteDisposalPreviewComponent
} from '../application/municipal-waste-disposal/municipal-waste-disposal-preview/municipal-waste-disposal-preview.component';
import {
  CoordinatingTrafficOrganizationProjectsPreviewComponent
} from '../application/coordinating-traffic-organization-projects/coordinating-traffic-organization-projects-preview/coordinating-traffic-organization-projects-preview.component';
import {
  DecisionOnDevelopmentConditionsPreviewComponent
} from '../application/decision-on-development-conditions/decision-on-development-conditions-preview/decision-on-development-conditions-preview.component';
import {
  OpinionOfConformityOfPropertyDivisionMpzpPreviewComponent
} from '../application/opinion-of-conformity-of-property-division-mpzp/opinion-of-conformity-of-property-division-mpzp-preview/opinion-of-conformity-of-property-division-mpzp-preview.component';
import {
  DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentPreviewComponent
} from '../application/decision-on-determining-the-location-of-a-public-purpose-investment/decision-on-determining-the-location-of-a-public-purpose-investment-preview/decision-on-determining-the-location-of-a-public-purpose-investment-preview.component';

@Component({
  selector: 'app-sent-preview-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    RouterModule,
    CommonModule,
    SpinnerComponent,
    AlertContainerComponent,
    WLocationPropertyInRevitalizationAreaPreviewComponent,
    WCertificateFromMunicipalRegisterPreviewComponent,
    WExtractAndDraftMpzpPreviewComponent,
    WExtractAndDraftFromStudyPreviewComponent,
    CertAboutConformityOfUseWithMpzpPreviewComponent,
    OpinionOfConformityPreviewComponent,
    IrspaApplicationForTheProjectPreviewComponent,
    IrspaWarningOnTheConsultedDraftPreviewComponent,
    IrspaAmendTheActPreviewComponent,
    IrspaPreparationOfTheActPreviewComponent,
    DocumentsInformationPreviewComponent,
    GeneralLetterPreviewComponent,
    ResponseToCallPreviewComponent,
    CertAboutConformityOfStudyPreviewComponent,
    LeaseOfABurialPlacePreviewComponent,
    ApplicationForACemeterySpacePreviewComponent,
    RegistrationForTheSewageTreatmentPlantRegisterPreviewComponent,
    WDeterminingPlanningFeeBeforeSaleOfPropertyPreviewComponent,
    SubmittingAnInvestorLetterOfIntentPreviewComponent,
    GeneralApplicationPreviewComponent,
    RemovalOfTreesOrShrubsPreviewComponent,
    MunicipalWasteDisposalPreviewComponent,
    CoordinatingTrafficOrganizationProjectsPreviewComponent,
    DecisionOnDevelopmentConditionsPreviewComponent,
    OpinionOfConformityOfPropertyDivisionMpzpPreviewComponent,
    DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentPreviewComponent
  ],
  providers: [UploaderAttachmentsService, PdfGeneratorService],
  templateUrl: './sent-preview-page.component.html'
})
export class SentPreviewPageComponent implements OnInit, OnDestroy {
  public applicationId: string | undefined =
    this.route.snapshot.params['appId'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> =
    this.store$.selectSignal(selectApplication);

  public contentUrl: string | undefined = this.route.snapshot.params['contentUrl'];

  public serviceType: Signal<ServiceAppEntityServiceRead | null> =
    this.store$.selectSignal(
      selectServiceByUrl(this.contentUrl || '')
    );

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private uploaderService: UploaderAttachmentsService,
    private pdfGeneratorService: PdfGeneratorService,
    private alertService: AlertService
  ) {
  }

  public onDownloadApplicationPdf(event: Event): void {
    const id = this.application()?.document?.id;
    const name = this.application()?.document?.originalName;
    event.preventDefault();
    event.stopPropagation();
    if (id && name) {
      this.uploaderService.downloadAttachment(id, name).toPromise().then();
    }
  }

  public onDownloadUpd(event: Event): void {
    const id = this.application()?.uuid;
    event.preventDefault();
    event.stopPropagation();
    if (id) {
      this.pdfGeneratorService.generateUPDPdf(id, 'upd.pdf').toPromise().then();
    }
  }

  public onDownloadSignedApplication(event: Event): void {
    const id = this.application()?.signedDocument?.id;
    const name = this.application()?.signedDocument?.originalName;
    event.preventDefault();
    event.stopPropagation();
    if (id && name) {
      this.uploaderService.downloadAttachment(id, name).toPromise().then();
    }
  }

  public ngOnInit(): void {
    this.alertService.showByApplicationCode(history.state?.message);

    this.store$.dispatch(loadApplication({ id: this.applicationId || '' }));
    this.store$.dispatch(loadPayments({ applicationId: this.applicationId || '' }));
    this.store$.dispatch(loadRoadOccupationTypes());
    this.store$.dispatch(loadServiceAttachmentPositions({ appId: this.applicationId || '' }));
  }

  public ngOnDestroy(): void {
    this.store$.dispatch(setApplication({ application: null }));
    this.store$.dispatch(setPayments({ applicationPayment: null }));
    this.store$.dispatch(setShipments({ shipments: [] }));
  }
}
